import styled from 'styled-components';

export var PageContainer = styled.div`
    display: flex;
    gap: 0;
    margin-top: 16px;
`;

export var SideMenu = styled.div`
    width: ${function(p) { return p.collapsed ? '56px' : '240px'; }};
    min-width: ${function(p) { return p.collapsed ? '56px' : '240px'; }};
    background: #fff;
    border-radius: 8px 0 0 8px;
    border-right: 1px solid #f0f0f0;
    padding: 0;
    transition: width 0.2s, min-width 0.2s;
    overflow: visible;
    display: flex;
    flex-direction: column;
    position: relative;

    .ant-menu {
        border-right: none;
    }

    .ant-menu-inline, .ant-menu-vertical {
        border-right: none;
    }

    .ant-menu-inline-collapsed {
        width: 56px;
    }

    .ant-menu-inline-collapsed > .ant-menu-item {
        padding: 0 !important;
        text-align: center;

        a {
            justify-content: center;

            span {
                display: none;
            }
        }
    }

    .ant-menu-item {
        margin: 1px 6px;
        padding: 0 12px !important;
        border-radius: 6px;
        height: 36px;
        line-height: 36px;
        overflow: hidden;

        &:hover {
            background: #f0f5ff;
        }

        &.ant-menu-item-selected {
            background: #e6f7ff;
            color: #1890ff;
            font-weight: 500;

            &:after {
                display: none;
            }
        }

        a {
            color: inherit;
            display: flex;
            align-items: center;
            gap: 10px;
            overflow: hidden;
            white-space: nowrap;
        }

        i, svg {
            font-size: 15px;
            flex-shrink: 0;
            width: 16px;
            text-align: center;
        }
    }

    .ant-menu-submenu-title {
        margin: 1px 6px;
        padding: 0 12px !important;
        border-radius: 6px;
        height: 36px;
        line-height: 36px;

        i, svg {
            font-size: 15px;
            width: 16px;
            text-align: center;
        }

        &:hover {
            background: #f0f5ff;
        }
    }
`;

export var SectionLabel = styled.div`
    font-size: 10px;
    font-weight: 700;
    color: #8c8c8c;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    padding: 14px 18px 4px;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;

    &:first-child {
        margin-top: 0;
        padding-top: 12px;
    }
`;

export var CollapseToggle = styled.div`
    position: absolute;
    top: 50%;
    right: -12px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #8c8c8c;
    z-index: 5;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08);
    transition: all 0.2s;

    &:hover {
        color: #1890ff;
        border-color: #1890ff;
        box-shadow: 0 2px 8px rgba(24,144,255,0.15);
    }

    i {
        font-size: 12px;
    }
`;

export var ContentArea = styled.div`
    flex: 1;
    background: #fff;
    border-radius: 0 8px 8px 0;
    padding: 24px;
    min-height: 500px;
    min-width: 0;
    overflow-x: auto;
`;

export var ContentTitle = styled.h2`
    font-size: 18px;
    font-weight: 600;
    color: #262626;
    margin: 0 0 20px 0;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;
`;

export var UserAvatarGroup = styled.div`
    display: flex;
    align-items: center;
    margin-left: 12px;

    .ant-avatar {
        border: 2px solid #fff;
        margin-left: -8px;
        cursor: pointer;

        &:first-child {
            margin-left: 0;
        }
    }
`;

export var UsersHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    flex-wrap: wrap;
`;

export var PermissionCard = styled.div`
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    padding: 12px 16px;
    margin-bottom: 8px;
    transition: all 0.2s ease;

    &:hover {
        border-color: #d9d9d9;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }
`;

export var PermissionCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export var PermissionCardTitle = styled.div`
    font-size: 15px;
    font-weight: 500;
    color: #262626;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export var PermissionCardActions = styled.div`
    display: flex;
    gap: 8px;
`;

export var ActionButton = styled.button`
    background: none;
    border: none;
    padding: 4px 8px;
    cursor: pointer;
    color: #8c8c8c;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    transition: all 0.2s;

    &:hover {
        background: #f5f5f5;
        color: #595959;
    }

    &.danger:hover {
        background: #fff1f0;
        color: #ff4d4f;
    }
`;

export var UserCard = styled.div`
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    padding: 14px 16px;
    margin-bottom: 8px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 14px;

    &:hover {
        border-color: #d9d9d9;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }
`;

export var UserCardInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export var UserCardName = styled.div`
    font-size: 15px;
    font-weight: 500;
    color: #262626;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export var UserCardEmail = styled.div`
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
`;

export var UserCardMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
`;

export var StatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    padding: 2px 10px;
    border-radius: 10px;
    background: ${function(props) {
        if (props.status === 'Ativo') return '#f6ffed';
        if (props.status === 'Convidado') return '#f9f0ff';
        if (props.status === 'Desativado') return '#fff1f0';
        return '#f5f5f5';
    }};
    color: ${function(props) {
        if (props.status === 'Ativo') return '#52c41a';
        if (props.status === 'Convidado') return '#722ed1';
        if (props.status === 'Desativado') return '#ff4d4f';
        return '#8c8c8c';
    }};

    &:before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: currentColor;
    }
`;

export var PermissionBadge = styled.span`
    font-size: 12px;
    color: #722ed1;
    background: #f9f0ff;
    padding: 2px 10px;
    border-radius: 10px;
    white-space: nowrap;
`;

export var UserGroupSection = styled.div`
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export var UserGroupHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
`;

export var UserGroupTitle = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: #595959;
`;

export var UserGroupCount = styled.span`
    font-size: 12px;
    color: #8c8c8c;
    background: #f5f5f5;
    padding: 1px 8px;
    border-radius: 10px;
`;

export var ViewToggle = styled.div`
    display: flex;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
    height: 32px;

    button {
        background: #fff;
        border: none;
        padding: 0 12px;
        height: 100%;
        cursor: pointer;
        display: flex;
        align-items: center;
        color: #8c8c8c;
        transition: all 0.2s;

        &:not(:last-child) {
            border-right: 1px solid #d9d9d9;
        }

        &.active {
            background: #722ed1;
            color: #fff;
        }

        &:hover:not(.active) {
            color: #722ed1;
        }
    }
`;

export var OrgChartContainer = styled.div`
    overflow-x: scroll;
    overflow-y: visible;
    padding: 20px 0;
    width: 100%;
    -webkit-overflow-scrolling: touch;
`;

export var OrgTreeWrapper = styled.div`
    display: flex;
    justify-content: center;
    min-width: fit-content;
`;

export var OrgTree = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 40px;
    white-space: nowrap;
`;

export var OrgRootCard = styled.div`
    display: inline-block;
    padding: 16px 24px;
    background: linear-gradient(135deg, #722ed1 0%, #531dab 100%);
    border-radius: 12px;
    color: #fff;
    text-align: center;
    box-shadow: 0 4px 12px rgba(114, 46, 209, 0.3);

    .title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 4px;
    }

    .subtitle {
        font-size: 12px;
        opacity: 0.8;
    }
`;

export var OrgConnector = styled.div`
    width: 2px;
    height: 24px;
    background: #d9d9d9;
    margin: 0 auto;
`;

export var OrgBranchContainer = styled.div`
    display: flex;
    justify-content: center;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 70px;
        right: 70px;
        height: 2px;
        background: #d9d9d9;
    }
`;

export var OrgBranch = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        width: 2px;
        height: 24px;
        background: #d9d9d9;
    }
`;

export var OrgGroupCard = styled.div`
    display: inline-block;
    padding: 12px 20px;
    background: ${function(props) { return props.isCustom ? '#fff7e6' : '#f9f0ff'; }};
    border: 2px solid ${function(props) { return props.isCustom ? '#ffd591' : '#b37feb'; }};
    border-radius: 10px;
    text-align: center;
    min-width: 140px;
    cursor: pointer;
    transition: all 0.2s;
    margin-top: 24px;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .anticon {
        font-size: 20px;
        color: ${function(props) { return props.isCustom ? '#fa8c16' : '#722ed1'; }};
        margin-bottom: 6px;
    }
`;

export var OrgGroupTitle = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #262626;
`;

export var OrgGroupCount = styled.div`
    font-size: 11px;
    color: #8c8c8c;
    margin-top: 2px;
`;

export var OrgUsersGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin-top: 16px;
    max-width: 320px;
`;

export var OrgUserCard = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    text-align: left;

    &:hover {
        border-color: #d9d9d9;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
`;

export var OrgUserInfo = styled.div`
    min-width: 0;
`;

export var OrgUserName = styled.div`
    font-size: 11px;
    font-weight: 500;
    color: #262626;
    white-space: nowrap;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export var OrgUserEmail = styled.div`
    font-size: 9px;
    color: #8c8c8c;
    white-space: nowrap;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
`;
